import type { IconProps } from '@openeducation/oe-rn-shared-types';
import React from 'react';
import Svg, { Path } from 'react-native-svg';

export const CrownIcon = ({ fill }: IconProps) => {
  return (
    <Svg width={26} height={20} viewBox="0 0 26 20" fill="none">
      <Path
        d="M21.125 17.5H4.875C4.52344 17.5 4.25 17.8125 4.25 18.125V19.375C4.25 19.7266 4.52344 20 4.875 20H21.125C21.4375 20 21.75 19.7266 21.75 19.375V18.125C21.75 17.8125 21.4375 17.5 21.125 17.5ZM23.625 5C22.5703 5 21.75 5.85937 21.75 6.875C21.75 7.1875 21.7891 7.42187 21.9062 7.65625L19.0937 9.375C18.4687 9.72656 17.6875 9.53125 17.3359 8.90625L14.1719 3.32031C14.6016 3.00781 14.875 2.46094 14.875 1.875C14.875 0.859375 14.0156 0 13 0C11.9453 0 11.125 0.859375 11.125 1.875C11.125 2.46094 11.3984 3.00781 11.7891 3.32031L8.625 8.90625C8.27344 9.53125 7.49219 9.72656 6.90625 9.375L4.05469 7.65625C4.17187 7.42187 4.25 7.1875 4.25 6.875C4.25 5.85937 3.39062 5 2.375 5C1.32031 5 0.5 5.85937 0.5 6.875C0.5 7.92969 1.32031 8.75 2.375 8.75C2.45312 8.75 2.57031 8.75 2.64844 8.75L5.5 16.25H20.5L23.3125 8.75C23.3906 8.75 23.5078 8.75 23.625 8.75C24.6406 8.75 25.5 7.92969 25.5 6.875C25.5 5.85937 24.6406 5 23.625 5Z"
        fill={fill}
      />
    </Svg>
  );
};

export default CrownIcon;
